import React from 'react';
import './ChecklistConfirm.scss';

// Cherry-picked from feature/LT-2951_Nutrition-And-Rehabilitation (ConfirmButton)
const COLOR_PRESETS = {
  green: {
    active: {
      background: 'linear-gradient(135deg, #057036, #51BA62)',
      border: 'linear-gradient(132.38deg, #ABECB0, #16570A)',
      textColor: '#FFFFFF',
      boxShadow: '4px 4px 18px 0px #BEDEC3',
    },
    disabled: {
      background: 'linear-gradient(135deg, #F2F2F2, #F2F2F2)',
      border: 'linear-gradient(132.38deg, #FAFAFA, #E4E8E5)',
      textColor: '#A7ABA8',
      boxShadow: 'none',
    },
  },
};

/**
 * Submit button for begin challenge checklist footer.
 * Ported from ConfirmButton in feature/LT-2951_Nutrition-And-Rehabilitation.
 *
 * @param {string}   text     - button label (default: "ส่งคำตอบ")
 * @param {string}   width    - optional width override
 * @param {boolean}  disabled - greys out when not all questions answered
 * @param {boolean}  loading  - shows loading text while submitting
 * @param {function} onClick  - called when button is tapped (and not disabled/loading)
 */
const ChecklistConfirm = ({
  text = 'ส่งคำตอบ',
  width = undefined,
  disabled = false,
  loading = false,
  onClick = () => {},
}) => {
  const preset = COLOR_PRESETS.green;
  const isDisabled = disabled || loading;
  const colorStyle = isDisabled ? preset.disabled : preset.active;

  return (
    <div
      className={`confirm-button-container${isDisabled ? ' confirm-button-disabled' : ''}`}
      onClick={!isDisabled ? onClick : undefined}
      style={{
        ...(width && { width }),
        background: `${colorStyle.background} padding-box, ${colorStyle.border} border-box`,
        boxShadow: colorStyle.boxShadow,
      }}
    >
      <div className="confirm-button-text" style={{ color: colorStyle.textColor }}>
        {loading ? 'กำลังส่ง...' : text}
      </div>
    </div>
  );
};

export default ChecklistConfirm;
